import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";

class BotBasedPricing extends Component {
    constructor() {
        super();
        this.state = {
            data: [
                {
                    planType: "STARTER",
                    monthlyBilling: "₹ 1,199 per bot/month",
                    yearlyBilling: "₹ 999 per bot/month"
                },
                {
                    planType: "PROFESSIONAL",
                    monthlyBilling: "₹ 1,899 per bot/month",
                    yearlyBilling: "₹ 1,599 per bot/month",
                },
                {
                    planType: "PREMIUM",
                    monthlyBilling: "₹ 3,099 per bot/month",
                    yearlyBilling: "₹ 2,499 per bot/month",
                }
            ]
        }
    }

    goBackToProjectPlanPage = () => {
        this.props.history.push('/project-plan-settings');
    }

    render() {
        const columns = [
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Plan Type</b></div>),
                accessor: 'planType',
                sortable: false,
                style: { textAlign: "center" },
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.planType}</div>
                )
            },
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Monthly Billing</b></div>),
                accessor: 'monthlyBilling',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.monthlyBilling}</div>
                )
            },
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Yearly Billing</b></div>),
                accessor: 'yearlyBilling',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.yearlyBilling}</div>
                )
            },
        ]
        return (<div>
            <link href="assets/css/ej2-base.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
            <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="./assets/css/adminlte.css" />
            <link rel="stylesheet" href="./assets/css/styles.css" />
            <link rel="stylesheet" href="./assets/css/custom-style.css" />
            <link rel="stylesheet" href="./plugins/iCheck/all.css" />
            {/* for reactTable */}
            <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
            <link rel="stylesheet" href="./assets/css/react-table-height.css" />


            <div className="wrapper ">
                <div className="">
                    <div className="row">
                        <div className="col-12">
                            <div className="">
                                <div className="card-body " style={{ padding: '2.5% 2.5% 2.5% 2.5%' }}>
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8" style={{
                                            padding: "70px", border: "1px solid",
                                            borderRadius: "10px"
                                        }}>
                                            <a className="navbar-brand" href="https://www.dhee.ai"></a>
                                            <div className="row">
                                                <img src="assets/images/dheeai.png" alt="" style={{ height: "53px", width: "150px" }} />
                                                <span className="signinTitle" style={{ marginLeft: "200px", Align: "right" }} ><b>BOT BASED PRICING</b></span>
                                            </div>
                                            <ReactTable
                                                data={this.state.data}
                                                columns={columns}
                                                defaultPageSize={3}
                                                showPagination={false}
                                                style={{
                                                    backgroundColor: 'white',
                                                    marginTop: '25px'
                                                }}
                                            /> <br /><br />
                                            <div Align="center">For <b>ENTERPRISE</b> plan Contact our sales at +919953593592</div><br />
                                            <div Align="center">*Voice calls rate @45paise per 15sec will be billed over the bot charges</div>
                                            <div Align="center" style={{ marginTop: "40px" }}>
                                                <button className="btn btn-primary saveChangesBtn"
                                                    title="Back" onClick={this.goBackToProjectPlanPage}>
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default BotBasedPricing;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/pricingDetails/BotBasedPricing.js